module.exports = __webpack_public_path__ + "static/img/fullscreen.bd863333.png";